export default {
    dateISOString(d) { 
        if(!d) { 
            d = new Date()
        }

        let y = d.getFullYear().toString()
        let m = (d.getMonth()+1).toString()
        let day = d.getDate().toString()

        return y + '-' + (m.length > 1 ? m : '0' + m) + '-' + (day.length > 1 ? day : '0' + day)
    },  
}